import React from 'react'
import { useSendAppLoaded } from './hooks/useSendAppLoaded'

export const ProfileEventRegistration: React.FC = (props) => {
  useSendAppLoaded()
  return <>{props.children}</>
}
